import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import * as yup from "yup";
import { useFormik } from 'formik';
import Button from "@mui/material/Button";
import { enqueueSnackbar } from "notistack";
import { WIZARD } from "../../../../../src/thinkPlus/locales/namespaces";
import { useWizard } from "../../LoanApplicationContext";
import OTP from "../../../../../src/thinkPlus/components/elements/OtpField";
import { OTP_LENGTH } from "../../../../../src/thinkPlus/components/wizard/constants";
import CountDownTimer from "../../../../../src/thinkPlus/components/elements/CountDownTimer";




const CodeAccessApplication = () => {
	const [showOtp, setShowOtp] = useState(false);
	const [otp, setOtp] = useState('');

	const [countDownTrigger, setCountDownTrigger] = useState(0);

	const { t } = useTranslation(WIZARD);
	const { summary, validateUser, importUser, data, userData, responses } = useWizard();


	const formik = useFormik({
		initialValues: {
			email: userData.email || "",
		},
		validationSchema: yup.object({
			email: yup.string().email(t('Invalid email')).required(t("Required")),
		}),
		onSubmit: (values) => {
			if (!otp) {
				return importUser({
					email: userData.email,
					onSuccess: () => setShowOtp(true),
				});
			}
		}
	});

	const handleResend = () => {
		validateUser({
			email: userData.email || "",
			onSuccess: () => {
				setOtp("");
				setCountDownTrigger((prev) => prev + 1);
				enqueueSnackbar(
					t("A new code has been sent in your email"),
					{ variant: "success" }
				)
			},
		});
	}

	return (
		<>
			<Typography>
				{t("Enter the code you received in your email")}
			</Typography>
			<OTP value={otp} onChange={setOtp} length={OTP_LENGTH} />
			<Typography sx={{ mt: 2 }}>
				{t("The code will be active for")}{" "}
				<CountDownTimer key={countDownTrigger} minutes={5} />
			</Typography>
			<Button
				sx={{ fontSize: "14px", textDecoration: "underline" }}
				onClick={handleResend}
			>
				{t("Resend")}
			</Button>

			<LoadingButton
				variant="contained"
				color="info"
				sx={{ display: "block", mx: "auto", mt: 3, p: "12px 32px" }}
				onClick={formik.handleSubmit}
				disabled={formik.isSubmitting}
				loading={formik.isSubmitting}
			>
				{t("Submit")}
			</LoadingButton>
		</>


	);
}

export default CodeAccessApplication;
